import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import dashboardReducer from "../features/dashboard/dashboardSlice";
import customerReducer from "../features/cutomers/customerSlice";
import productReducer from "../features/product/productSlice";
import brandReducer from "../features/brand/brandSlice";
import pCategoryReducer from "../features/pcategory/pcategorySlice";
import bCategoryReducer from "../features/category/categorySlice";
import blogReducer from "../features/blogs/blogSlice";
import sectorReducer from "../features/sectors/sectorSlice";
import clusterReducer from "../features/cluster/clusterSlice";
import statecityReducer from "../features/statecity/statecitySlice";
import curriculamReducer from "../features/curriculam/curriculamSlice";
import trainningschduleReducer from "../features/trainning-schdule/trainningschduleSlice";
import guestlecturesReducer from "../features/guest-lectures/guestlectureSlice";
import industrialvisitReducer from "../features/industrial-visit/industrialSlice";
import mouReducer from "../features/mou/mouSlice";
import assesmentlistReducer from "../features/assesments/assesmentSlice";
import placementListReducer from "../features/placements/placementSlice";
import studentReducer from "../features/students/studentSlice";
import attendanceReducer from "../features/attendance/attendanceSlice";
import vacantListReducer from "../features/vacantposition/vacantSlice";
import paymentReducer from "../features/payments/paymentSlice";
import salaryReducer from "../features/salary-record/salarySlice";
import schoolReducer from "../features/schools/schoolSlice";
import colorReducer from "../features/color/colorSlice";
import enquiryReducer from "../features/enquiry/enquirySlice";
import uploadReducer from "../features/upload/uploadSlice";
import couponReducer from "../features/coupon/couponSlice";
import invoiceReducer from "../features/invoice/invoiceSlice";
import performanceReducer from "../features/weeklyReview/performanceSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    customer: customerReducer,
    dashboard: dashboardReducer,
    product: productReducer,
    brand: brandReducer,
    pCategory: pCategoryReducer,
    bCategory: bCategoryReducer,
    blogs: blogReducer,
    sectors: sectorReducer,
    cluster: clusterReducer,
    statecity: statecityReducer,
    curriculam: curriculamReducer,
    trainningschdule: trainningschduleReducer,
    guestlectures: guestlecturesReducer,
    industrialvisit: industrialvisitReducer,
    mou: mouReducer,
    assesmentlist: assesmentlistReducer,
    placementList: placementListReducer,
    vacantList: vacantListReducer,
    student: studentReducer,
    attendance: attendanceReducer,
    school: schoolReducer,
    payment: paymentReducer,
    invoice: invoiceReducer,
    salary: salaryReducer,
    color: colorReducer,
    enquiry: enquiryReducer,
    upload: uploadReducer,
    coupon: couponReducer,
    performance: performanceReducer,
  },
});
